/**
 * Returns HTML markup for results
 *
 * @param {int} pagesCurrent
 * @param {int} itemsPerPage
 * @param {int} itemsTotal
 * @returns {string}
 */
export function getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal) {
  let start = (pagesCurrent * itemsPerPage) - (itemsPerPage - 1);
  let end = Math.min(start + itemsPerPage - 1, itemsTotal);
  return Drupal.t('Showing') + ` ${start} – ${end} of ${itemsTotal}`;
}
